import React from "react";
import "../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import Facebook from "../../assets/facebook.png";
import Gmail from "../../assets/gmail.png";
// import { FaFacebook } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Loginimg from "../../assets/logincommunityx.png";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { EmailCheck } from "../../ConditionChecks/ConditionChecks";
import { useState } from "react";
import { LoginUser } from "../../Utils/Api/LoginUser";
import Validate from "../SignUp/Alert";
import { RotatingLines } from "react-loader-spinner";
// import { Toast } from "react-toastify";
import { toast } from "react-toastify";
import SocialLogins from "../../Components/SocialLogin/SocialLogin";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import Loader from "../../Components/Loader/Loader";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { useSelector } from "react-redux";
import { setUserCredentials } from "../../Utils/LocalStorage";

const SignIn = ({ status }) => {
  const [signInEmail, setSignInEmail] = useState("");
  const [signInPassword, setSignInPassword] = useState("");
  const [errEmailDisplay, setErrEmailDisplay] = useState("");
  const [errPasswordDisplay, setErrPasswordDisplay] = useState("");
  const [apiErrDisplay, setApiErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [visibleOldPassword, setVisibleOldPassword] = useState(true);

  // Redux Data
  const ReduxData = useSelector((state) => state);

  // Charge bee check flag
  const CheckChargebeeSubscriptionFlag =
    ReduxData.CheckChargebee.CheckChargebeeSubscription;

  const onOldPassword = (e) => {
    let oldpswd = e.target.value;
    setOldPassword(oldpswd);
  };
  const OldPasswordVisibleHandler = () => {
    setVisibleOldPassword(true);
  };
  const OldPasswordNotVisibleHandler = () => {
    setVisibleOldPassword(false);
  };
  const [mainloading, setMainloading] = useState(false);

  const onEmail = (event) => {
    let email = event.target.value;
    setSignInEmail(email);
    const EmailValidationOnChange = EmailCheck(email);
    if (EmailValidationOnChange.input === "empty") {
      setErrEmailDisplay("");
    } else if (EmailValidationOnChange.input === "invalid") {
      setErrEmailDisplay(EmailValidationOnChange.err_display);
    } else if (EmailValidationOnChange.validition === true) {
      setErrEmailDisplay("");
    }
    // setErrEmailDisplay("");
    setApiErrDisplay("");
  };

  const onPassword = (e) => {
    setSignInPassword(e.target.value);
    setErrPasswordDisplay("");
    setApiErrDisplay("");
  };

  // function used to navigate to other routes
  const navigate = useNavigate();

  // console.log(location.state.status);

  // LoginHandler function is performing API call, sending the parameter through LoginUser function,
  //  setting up the error display and authenticating the user to redirect into dashboard
  const LoginHandler = async (LoginCredentials) => {
    setLoading(true);
    const userLoginData = await LoginUser(LoginCredentials);
    if (userLoginData === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "auto",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (userLoginData.success === true) {
        setUserCredentials(userLoginData);
        setSignInEmail("");
        setSignInPassword("");

        // independent page
        localStorage.setItem("independentSlug", userLoginData.business_slug);
        setTimeout(() => {
          toast.success("Login Successful!", {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          navigate(
            CheckChargebeeSubscriptionFlag === true
              ? "/my-profile/subscription"
              : "/dashboard"
          );
          setLoading(false);
        }, 1000);
      } else if (userLoginData.success === false) {
        toast.error(userLoginData.bu_status, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  // Sign in handler function which is checking conditions and setting error labels.
  // if its stasisying all the condition its been stored in a variable and sent as parameter to LoginHandler function
  const SignInHandler = (e) => {
    e.preventDefault();
    let check = true;
    const EmailValidation = EmailCheck(signInEmail);

    if (EmailValidation.input === "empty") {
      setErrEmailDisplay(EmailValidation.err_display);
      check = false;
    } else if (EmailValidation.input === "invalid") {
      setErrEmailDisplay(EmailValidation.err_display);
      check = false;
    }

    if (!signInPassword) {
      setErrPasswordDisplay("Password is required!");
      check = false;
    }

    if (check === true) {
      let LoginCredentials = {
        bu_email: signInEmail.trim(),
        bu_password: signInPassword.trim(),
      };
      LoginHandler(LoginCredentials);
    }
  };

  return (
    <>
      {mainloading === true ? <Loader /> : <></>}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col xs lg="6" className="page-content-left hide-mobile">
              <Image
                loading="lazy"
                src={Loginimg}
                width="100%"
                className="mt-5 pt-5"
              ></Image>
              <p className="login-text1 mt-4">
                Unlock the Power of Online Promotions!
              </p>
              <p className="login-text2 mt-2">
                Log in now and boost your sales and increase customer loyalty
                with our easy-to-use voucher and coupon platform. Create
                vouchers/coupons and reach thousands of potential customers.
              </p>
               <p className="login-text1 mt-4">Shop Local Digital is  now CommunityX Digital!</p>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mt-5 mb-2">
                {status === true ? <Validate /> : <></>}
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <h1 className="sign-second mt-4 pt-0">Business User Login</h1>
              </div>
              <Row>
                <div className="signemail py-3">
                  <Form
                    onSubmit={SignInHandler}
                    className="formmain signin-row"
                  >
                    <Form.Group className="" controlId="formBasicEmail">
                      <Form.Label className="form-label-custom">
                        Email address <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Your Email Address"
                        className="custom-formcontrol"
                        onChange={onEmail}
                        value={signInEmail}
                        autoComplete="off"
                      />
                      <ErrorLabel ErrorDisplay={errEmailDisplay} />
                    </Form.Group>

                    <Form.Group
                      className=""
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        Password <span className="star-required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={visibleOldPassword === true ? "password" : ""}
                          placeholder="Password"
                          className="custom-formcontrol"
                          onChange={onPassword}
                          value={signInPassword}
                          autoComplete="off"
                        />
                        {visibleOldPassword === true ? (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={OldPasswordNotVisibleHandler}
                          >
                            <FaEyeSlash className="eyeIcon" />
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={OldPasswordVisibleHandler}
                          >
                            <FaEye className="eyeIcon" />
                          </Button>
                        )}
                      </div>
                      <ErrorLabel ErrorDisplay={errPasswordDisplay} />

                      <Link
                        to="/forgotpassword"
                        className="text-right"
                      // onClick={ForgotPasswordHandler}
                      >
                        <p className="forgot-text">Forgot Password</p>
                      </Link>
                    </Form.Group>
                    <div className="text-center">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn"
                        style={{ marginTop: "35px" }}
                      >
                        {loading === true ? (
                          <RotatingLines
                            strokeColor="white"
                            width={20}
                            visible={true}
                          />
                        ) : (
                          "Login"
                        )}
                      </Button>
                      <div
                        className={
                          apiErrDisplay === "Successful!"
                            ? "successful pt-3"
                            : "failed pt-3"
                        }
                      >
                        {apiErrDisplay}
                      </div>
                      {/* <br /> */}
                      {/* <Link to="/explore">Explore</Link> */}
                    </div>
                  </Form>
                  <p className="dont-acc text-center">
                    Don’t have account?{" "}
                    <Link to="/signup" className="signup-text">
                      Sign Up
                    </Link>
                  </p>

                </div>
              </Row>
              <div className="link-container">
                <a
                  href="https://meylah.com/privacy-policy/"
                  target="_blank"
                >
                  <p className="link-text text-center">Privacy Policy</p>
                </a>
                <span style={{ color: "#fff" }}>|</span>
                <a href="https://meylah.com/termsofuse/" target="_blank">
                  <p className="link-text text-center">
                    Terms & Conditions
                  </p>
                </a>
              </div>
              {/* <p className="loginwith">
                <span>Or Login with</span>
              </p>
              <SocialLogins SetLoadingFuc={setMainloading} />
              <p className="login_Text">
                You can login with Facebook or Google if you have used same
                e-mail address to sign up.
              </p> */}
              {/* <Row className="p-0 mb-3">
                <Col md="6" className="social-main social-main1">
                  <button className="signin-social px-3">
                    <Image loading="lazy"
                      src={Facebook}
                      width="35px"
                      className="social-icons"
                    ></Image>
                  </button>
                </Col>
                <Col md="6" className="social-main">
                  <button className="signin-social px-3">
                    <Image loading="lazy"
                      src={Gmail}
                      width="35px"
                      className="social-icons"
                    ></Image>
                  </button>
                </Col>
              </Row> */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SignIn;
